export default __webpack_public_path__ + "9415315ac12bfa77093f30a460b3c87c.jpg";